/**
 * Given any `arr` type and an async `shouldKeep` discriminator, returns a copy
 * `arr` with the items removed where `shouldKeep` returns false.
 */
export async function asyncFilter<T>(
  arr: T[],
  shouldKeep: (item: T) => Promise<boolean>
): Promise<T[]> {
  const items: T[] = [];

  for (const item of arr) {
    if ((await shouldKeep(item)) === true) {
      items.push(item);
    }
  }

  return items;
}
